/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-nested-ternary */
import React from 'react';

import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { NavLink } from 'react-router-dom';
import 'react-tippy/dist/tippy.css';
import ProductsData from '../../data/products';
import ROUTES from '../../data/routes';
import Helper from '../../helpers/string';

class MobileMenuCategories extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      principalCategories: [],
    };
  }

  componentDidMount() {
    const { categories } = this.props.settings;

    this.filterCategories(categories);
  }

  getCategoriesWithOrder = (categories = []) => {
    try {
      let ordersInAcum = 0;
      const maxCategories = ProductsData.maxSubMenuInBottom + 1;
      const categoriesOrdered = categories.reduce((acum, category) => {
        if (ordersInAcum < maxCategories) {
          const orderId = parseInt(category.order, 10);
          if (orderId) {
            acum.push(category);
            ordersInAcum += 1;
          }

          if (category.categories) {
            category.categories.forEach((subCategory) => {
              if (ordersInAcum < maxCategories) {
                const orderIdSub = parseInt(subCategory.order, 10);
                if (orderIdSub) {
                  acum.push(subCategory);
                  ordersInAcum += 1;
                }
              }
            });
          }
        }

        return acum;
      }, []);

      return categoriesOrdered;
    } catch (e) {
      console.error(e);
    }

    return [];
  };

  checkSustainable = (category, left = false) => {
    if (left && category.isSustainable) return { flex: 1, color: '#00b200' };
    if (category.isSustainable) return { color: '#00b200' };
    return {};
  };

  filterCategories = (categories = []) => {
    const clonedCategories = this.getCategoriesWithOrder(categories);
    const arrMenu = clonedCategories.length ? clonedCategories : categories;
    arrMenu.sort((a, b) => (
      a.order === b.order
        ? a.name < b.name
        : (a.order || Infinity) < (b.order || Infinity)
          ? -1
          : 1
    ));

    this.setState({
      principalCategories: arrMenu,
    });
  };

  renderCategories = () => {
    const { principalCategories } = this.state;

    const mainCategories = [];
    const subCategories = [];

    principalCategories.forEach((category) => {
      mainCategories.push(category);
      if (category.categories && category.categories.length > 0) {
        subCategories.push(...category.categories);
      }
    });

    return (
      <React.Fragment>
        <li>
          <NavLink
            activeClassName="destak"
            to="/"
            isActive={(match, location) => location.pathname === '/'}
            onClick={() => this.props.pushAndCloseLeftMenu(`${ROUTES.HOME}}`)}
          >
            {I18n.t('home')}
          </NavLink>
        </li>

        <li className="sub">
          <React.Fragment>
            <NavLink
              to={ROUTES.PRODUCTS}
              activeClassName="active"
              onClick={() => this.props.pushAndCloseLeftMenu(`${ROUTES.PRODUCTS}`)
              }
              style={{ display: 'flex' }}
            >
              <NavLink className="notTextDecoration" to={ROUTES.PRODUCTS}>
                {I18n.t('categories')}
              </NavLink>
              <p
                style={{
                  position: 'relative',
                  flex: 5,
                  cursor: 'pointer',
                }}
              />
            </NavLink>
          </React.Fragment>

          <div className="content-sub content-sub-mobile visible-when-active">
            <ul className="sub-ul">
              {subCategories.map(subCategory => (
                <React.Fragment key={subCategories.id}>
                  <li className="sub-cat">
                    <NavLink
                      to={`${ROUTES.PRODUCTS}?categories=${subCategories.id}`}
                      className="notTextDecoration"
                    >
                      <NavLink
                        to={`${ROUTES.PRODUCTS}?categories=${subCategories.id}`}
                        style={this.checkSustainable(subCategories)}
                      >
                        <h4 className="notTextDecoration" style={{ textDecoration: 'none' }}>{Helper.capitalizeFirstLetter(subCategory.name)}</h4>
                      </NavLink>
                    </NavLink>
                  </li>
                </React.Fragment>
              ))}
            </ul>
          </div>
        </li>

        {mainCategories.map(category => (
          <li className="sub" key={category.id}>
            <React.Fragment>
              <React.Fragment>
                <NavLink
                  to={ROUTES.PRODUCTS}
                  activeClassName="active"
                  onClick={() => this.props.pushAndCloseLeftMenu(`${ROUTES.PRODUCTS}`)}
                  style={{ display: 'flex' }}
                >
                  <NavLink
                    className="notTextDecoration"
                    onClick={() => this.props.pushAndCloseLeftMenu(`${ROUTES.PRODUCTS}`)}
                    to={ROUTES.PRODUCTS}
                  >
                    <span style={this.checkSustainable(category, true)}>
                      {Helper.capitalizeFirstLetter(category.name)}
                    </span>
                  </NavLink>
                  <p
                    style={{
                      position: 'relative',
                      flex: 5,
                      cursor: 'pointer',
                    }}
                  />
                </NavLink>

                <div className="content-sub content-sub-mobile visible-when-active">
                  <ul className="sub-ul">
                    {category.categories.map(subCategory => (
                      <React.Fragment key={subCategory.id}>
                        <li className="sub-cat">
                          <NavLink
                            to={`${ROUTES.PRODUCTS}?categories=${subCategory.id}`}
                            onClick={() => this.props.pushAndCloseLeftMenu(`${ROUTES.PRODUCTS}?categories=${subCategory.id}`)}
                          >
                            <NavLink
                              className="notTextDecoration"
                              to={`${ROUTES.PRODUCTS}?categories=${subCategory.id}`}
                              onClick={() => this.props.pushAndCloseLeftMenu(`${ROUTES.PRODUCTS}?categories=${subCategory.id}`)}
                            >
                              <h4 className="notTextDecoration" style={this.checkSustainable(subCategory, true)}>
                                {Helper.capitalizeFirstLetter(subCategory.name)}
                              </h4>
                            </NavLink>
                          </NavLink>
                        </li>
                      </React.Fragment>
                    ))}
                  </ul>
                </div>
              </React.Fragment>
            </React.Fragment>
          </li>
        ))}
      </React.Fragment>
    );
  };

  render() {
    return (
      <React.Fragment>
        <li>{this.renderCategories()}</li>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  settings: state.settings,
});

export default connect(mapStateToProps, undefined)(MobileMenuCategories);
